const initialState = {
  loaded: false,
  collection: [],
  pagination: {}
}

export default (state, action) => {
  switch (action.type) {
    case 'WORKFLOWS_OWNER_LIST_REQUEST':
      return {
        ...state,
        loaded: false
      }
    case 'WORKFLOWS_OWNER_LIST_DONE': {
      const { collection, pagination } = action.payload
      return {
        ...state,
        loaded: true,
        collection,
        pagination: {
          totalPages: pagination.total_pages,
          currentPage: pagination.current_page,
          totalCount: pagination.total_count,
          nextPage: pagination.next_page,
          pageSize: pagination.page_size
        }
      }
    }
    case 'WORKFLOWS_OWNER_LIST_FAIL':
      return {
        ...state,
        loaded: true
      }
    case 'WORKFLOWS_DELETE_SUCCESS': {
      const updatedOwnerIndex = state.collection.findIndex((ownerObject) => (
        ownerObject.type === action.payload.owner.type
        && ownerObject.id === action.payload.owner.id
      ))
      const ownerFromState = state.collection[updatedOwnerIndex]
      const ownerWorkflowsCollection = ownerFromState.workflows.collection.filter(
        (workflow) => (workflow.uuid !== action.payload.workflowUuid)
      )

      return {
        ...state,
        collection: [
          ...state.collection.slice(0, updatedOwnerIndex),
          {
            ...ownerFromState,
            workflows: {
              ...ownerFromState.workflows,
              collection: ownerWorkflowsCollection
            }
          },
          ...state.collection.slice(updatedOwnerIndex + 1)
        ]
      }
    }
    case 'WORKFLOWS_CLEAR_CREATION_FLAG':
      return {
        ...state,
        workflow_created: null
      }
    default:
      return {
        ...initialState,
        ...state
      }
  }
}
